import React, { FC, useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Loader from "../components/elements/Loader";
import { ReduxApplicationState } from "../types/ReduxTypes/ReduxApplicationState";
import { SentryRoute } from "../sentry";
import { getAppHomePath } from "../utils/getAppHomePath";
import { setIsAuthLoading, setSession } from "../redux/reducers/session";

type AuthManagementRouteProps = {
  exact?: boolean;
  path: string;
  component: React.ComponentType<any>;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const AuthManagementRoute: FC<AuthManagementRouteProps> = ({ component: Component, ...rest }) => {
  const isAuthenticated: boolean = useSelector((state: ReduxApplicationState) => state.session.isAuthenticated);
  const dispatch = useDispatch();

  const [isUserAuthenticatedChecking, setIsUserAuthenticatedChecking] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const checkAuthStatus = async () => {
      try {
        setIsUserAuthenticatedChecking(true);
        const user = await Auth.currentSession();
        if (isMounted) {
          if (user) {
            const session = {
              accessToken: user.getAccessToken().getJwtToken(),
              idToken: user.getIdToken().getJwtToken(),
              refreshToken: user.getRefreshToken().getToken(),
            };
            dispatch(setSession(session));
            dispatch(setIsAuthLoading(false));
            setIsUserAuthenticatedChecking(false);
          } else {
            setIsUserAuthenticatedChecking(false);
          }
        }
      } catch (error) {
        if (isMounted) {
          if (error === "No current user") {
            // eslint-disable-next-line no-console
            console.log("User is not Authenticated!");
            setIsUserAuthenticatedChecking(false);
            dispatch(setIsAuthLoading(false));
          } else {
            setIsUserAuthenticatedChecking(false);
            dispatch(setIsAuthLoading(false));
            // eslint-disable-next-line no-console
            console.log("error:", error);
          }
        }
      }
    };
    checkAuthStatus();
    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  return (
    <SentryRoute
      render={(props) => (
        <>
          {isAuthenticated ? (
            <Redirect to={{ pathname: getAppHomePath() }} />
          ) : (
            <>{isUserAuthenticatedChecking ? <Loader /> : <Component {...props} />}</>
          )}
        </>
      )}
      {...rest}
    />
  );
};

export default AuthManagementRoute;
